module.exports = __webpack_public_path__ + "static/img/icon_crjd.ae8ac771.png";